import {Component} from 'react';
import PropTypes from 'prop-types';
import {Header, Image} from 'semantic-ui-react';
import editIcon from '../images/editIcon.svg';
import EditableText from './EditableText';

export default class EditableTitle extends Component {
  static propTypes = {
    className: PropTypes.string,
    dividing: PropTypes.bool,
    onUpdateData: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    level: PropTypes.string,
    title: PropTypes.string,
    maxLength: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
    editFontSize: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
  };

  static defaultProps = {
    level: 'h3',
    maxLength: 24,
    dividing: true,
  };

  didUpdateText = ({rawText}) => {
    const {onUpdateData} = this.props;
    onUpdateData({title: rawText});
  };

  renderedTitle = () => {
    const {className, dividing, isEnabled, level, placeholder, title} = this.props;
    const additionalClassName = className? ` ${className}` : '';
    return (
      <Header as={level}
                className={`field${additionalClassName}`}
                disabled={!isEnabled}
                dividing={dividing}
                onClick={this.onClickHeader}>
        {title || <i className="placeholder">{placeholder}</i>} &nbsp; &nbsp;
        <Image style={{verticalAlign: 'baseline', height: '1.5rem'}} size="mini" src={editIcon}/>
      </Header>
    );
  };

  render() {
    const {className, isEnabled, maxLength, placeholder, title, editFontSize, width} = this.props;
    const editClassNames = ['sectionDataTitle', className].join(' ').trim();
    return (
      <EditableText
        onUpdateData={this.didUpdateText}
        editClassName={editClassNames}
        editIsEnabled={isEnabled}
        editMaxLength={maxLength}
        editStyle={{fontWeight: 400, fontSize: editFontSize || '1.33333333rem'}}
        placeholder={placeholder}
        rawText={title}
        renderedText={this.renderedTitle()}
        width={width || '100%'}
      />
    );
  }
}
